import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { ProviderStudioListItem } from "@shared-kernel/application/ports/provider/provider-repository";

export const retrieveProviderStudios = createAsyncThunk<ProviderStudioListItem[], void, { extra: Partial<Dependencies> }>(
  "provider/studios/retrieve",
  async (_, { extra: { providerRepository } }) => {
    return providerRepository!.listStudios();
  },
);
